<template>
  <v-card-text>
    <!-- 营业执照 -->
    <v-file-input
      multiple
      outlined
      clearable
      persistent-hint
      show-size
      chips
      hint="请上传您的营业执照图片,仅支持png,jpg,jpeg格式(按住ctrl可多选)"
      label="营业执照"
    ></v-file-input>

    <!-- 合作合同信息表 -->
    <v-file-input
      multiple
      outlined
      clearable
      persistent-hint
      show-size
      chips
      hint="请上传合作合同信息表"
      label="合作合同信息表"
    >
      <template v-slot:append>
        <v-btn text color="primary" @click="downloadTemplate">下载模板</v-btn>
      </template>
    </v-file-input>
  </v-card-text>
</template>

<script>
export default {
  data: () => {
    return {};
  },
  methods: {
    downloadTemplate() {
      console.log('下载模板');
    }
  }
};
</script>

<style>
</style>